import React,{useState} from 'react'

export default function TextArea(props) {
    const [text,setText]= useState("");

    const handleUpClick = () =>{
       let newtext = text.toUpperCase();
        setText(newtext);
        props.showAlert("Your text has been converted to Upper Case","success");
    }


    const handleLowClick= ()=>{
      let newtext = text.toLowerCase();
      setText(newtext);
      props.showAlert("Your text has been converted to Lower Case","success");
    }

    const handleCapClick= ()=>{
      text.charAt(1).toUpperCase();
      let words = text.split(" ");
      let newWord = "";
      let newText = "";
      for(let i=0; i<words.length;i++){
        newWord = words[i].substring(0,1).toUpperCase()+words[i].substring(1);
        newText = newText+ newWord+" ";
      }
      setText(newText);
      props.showAlert("Your text has been converted to Capitalized Case","success");
      }
    
      const handleClearClick = () =>{
       
        setText("");
        props.showAlert("Your text has been cleared","success");
      }
    

    const handleOnChange = (event) =>{
       
      setText(event.target.value);
    }
 
  return (
    <>
    <div className="container" style={{color:props.mode==="dark"?"white":"black"}} >
      
        <div className="mb-3">
        <label htmlFor="exampleFormControlTextarea1" className="form-label" ><h1>{props.heading}</h1></label>
        <textarea className="form-control" id="exampleFormControlTextarea1" rows="10" value={text} onChange={handleOnChange} style={{backgroundColor:props.mode==="dark"?"#50577A":"white", color:props.mode==="dark"?"white":"black"}}></textarea>
        </div>
        <button className="btn btn-primary mx-1" onClick={handleUpClick}>Covert to UPPER CASE</button>
        <button className="btn btn-primary mx-1" onClick={handleLowClick}>Convert to lower case</button>
        <button className="btn btn-primary mx-1" onClick={handleCapClick}>Convert to Captalized Case</button>
        <button className="btn btn-primary mx-1" onClick={handleClearClick}>Clear Text</button>
        
    </div>
    <div className="container my-3" style={{color:props.mode==="dark"?"white":"black"}}>
      <h6>Words : {text.trim() === '' ? 0 : text.match(/\S+/g).length}</h6>
      <h6>Characters : {text.replace(/\s+/g, '').length}</h6>
      <h6>Read time : {text.split(" ").length*0.004} minute</h6>
      <h2>Text Preview</h2>
      <p>{text.length>0?text:"Enter something in above textbox to get preview"}</p>
    </div>
    </>
  )
}
